import React from 'react';
import { Product } from '../types';
import styles from './styles/ProductCard.module.css';
import { getProductImageUrls } from '../utils';

interface ProductCardProps {
    product: Product;
}

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
    const {
        NombresProductos,
        Precio,
        marca,
        valor_propiedad_1, // Peso
    } = product;

    const formatoPrecio = new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS',
        minimumFractionDigits: 0 // Generalmente en ARS no se usan centavos en vista rápida
    }).format(Precio);

    const imageUrl = getProductImageUrls(product)[0];
    const outOfStock = product.stock_total !== null
        && product.stock_total !== undefined
        && product.stock_total <= 0;

    return (
        <div className={`${styles['product-card']} ${outOfStock ? styles['out-of-stock'] : ''}`}>
            {/* Etiquetas de oferta o stock (simulado con tags) */}
            <div className={styles['card-badges']}>
                {marca && <span className={`${styles.badge} ${styles['badge-brand']}`}>{marca}</span>}
                {outOfStock && <span className={`${styles.badge} ${styles['badge-stock']}`}>SIN STOCK</span>}
            </div>

            <div className={styles['card-image-container']}>
                {imageUrl ? (
                    <div className={styles['product-image-wrapper']}>
                        {/*
                          * lazy + async: las tarjetas fuera de pantalla no
                          * compiten por ancho de banda con las visibles.
                          * width/height fijan el aspect-ratio y evitan que la
                          * grilla salte cuando cada imagen termina de cargar.
                          */}
                        <img
                            src={imageUrl}
                            alt={NombresProductos}
                            className={styles['product-img']}
                            loading="lazy"
                            decoding="async"
                            width={400}
                            height={400}
                            onError={(e) => {
                                (e.target as HTMLImageElement).style.display = 'none';
                                (e.target as HTMLImageElement).nextElementSibling?.classList.remove(styles.hidden);
                            }}
                        />
                        <div className={`${styles['placeholder-img']} ${styles.hidden}`}>
                            <span>{NombresProductos.substring(0, 1)}</span>
                        </div>
                    </div>
                ) : (
                    <div className={styles['placeholder-img']}>
                        <span>{NombresProductos.substring(0, 1)}</span>
                    </div>
                )}
            </div>

            <div className={styles['card-info']}>
                <h3 className={styles['product-title']} title={NombresProductos}>
                    {NombresProductos}
                </h3>

                {/* Peso o unidad */}
                <p className={styles['product-weight']}>
                    {valor_propiedad_1 || 'Unidad'}
                </p>

                <div className={styles['price-block']}>
                    <span className={styles['current-price']}>{formatoPrecio}</span>
                </div>

                <div className={styles['card-actions']}>
                    <span className={`${styles['btn-buy']} ${outOfStock ? styles['btn-disabled'] : ''}`}>
                        {outOfStock ? 'SIN STOCK' : 'AGREGAR AL CARRITO'}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
